/**
 * Список закрепов выбранного треда Activity.
 * Рендерит sticky-зону пинов и пробрасывает обработчики действий
 * в дочерний `ActivityPinItem`.
 */
import { memo } from 'react';
import { Flex, Text } from '@mantine/core';
import type { ActivityChatPin } from '@ayocore/activity/common/types/activity-pin';
import { ActivityPinItem } from './ActivityPinItem';

type ActivityPinsListProps = {
  pins: ActivityChatPin[];
  pinsLoading: boolean;
  onPinClick?: (pin: ActivityChatPin) => void;
  onPinAction?: (pin: ActivityChatPin, actionId: string) => void;
};

function ActivityPinsListComponent({
  pins,
  pinsLoading,
  onPinClick,
  onPinAction,
}: ActivityPinsListProps) {
  return (
    <>
      {pinsLoading ? (
        <Flex align='center' justify='center' gap='xs' mb={4}>
          <Text size='xs' c='white'>
            Загрузка закрепов...
          </Text>
        </Flex>
      ) : null}

      {pins.length > 0 ? (
        <div
          style={{
            position: 'sticky',
            top: 0,
            zIndex: 2,
            marginTop: -4,
            marginInlineStart: -4,
            paddingBottom: 4,
          }}
        >
          <Flex gap={4} wrap='wrap'>
            {pins.map(pin => (
              <ActivityPinItem
                key={`pin-${pin.id}`}
                pin={pin}
                onClick={onPinClick}
                onAction={onPinAction}
              />
            ))}
          </Flex>
        </div>
      ) : null}
    </>
  );
}

export const ActivityPinsList = memo(
  ActivityPinsListComponent,
  (prev, next) => prev.pins === next.pins && prev.pinsLoading === next.pinsLoading
);
